import React from "react";

export default function AuditTab(){
  return (
    <>
      <div className="page-header">
        <h2 className="page-title">Journal d’audit</h2>
        <div className="page-actions">
          <button className="btn btn-outline"><i className="fas fa-file-export"></i> Export CSV</button>
        </div>
      </div>

      <div className="table-container">
        <div className="table-header">
          <h3 className="table-title">Actions récentes</h3>
          <div className="table-filters">
            <select className="filter-select"><option>Toutes actions</option></select>
            <select className="filter-select"><option>7 derniers jours</option></select>
          </div>
        </div>
        <table>
          <thead><tr><th>Date</th><th>Acteur</th><th>Action</th><th>Cible</th><th>Détails</th></tr></thead>
        <tbody>
          <tr><td>2025-11-05</td><td>owner@site.com</td><td>publish</td><td>listing:abc</td><td>—</td></tr>
        </tbody>
        </table>
        <div className="table-footer">
          <div className="table-info">1–1 sur 1</div>
          <div className="pagination"><button className="pagination-btn active">1</button></div>
        </div>
      </div>
    </>
  );
}
